module.exports = "<bs-navbar></bs-navbar>\r\n\r\n<div class=\"container\">\r\n  <router-outlet></router-outlet>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/React/Antique/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1